import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const adaConfig: TSPConfig = {
  key: 'ada',
  name: 'ADA',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API Key from ADA support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default adaConfig;
